"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAttr = function (element, key, value) {
    element.setAttribute(key, value);
};
exports.setAttrs = function (element, attrs) {
    for (var key in attrs) {
        if (attrs.hasOwnProperty(key)) {
            element.setAttribute(key, attrs[key]);
        }
    }
};
exports.getAttr = function (element, key) {
    var attr = element.getAttribute(key);
    return attr === null ? undefined : attr;
};
exports.getForcedAttr = function (element, key, alt) {
    var value = exports.getAttr(element, key);
    return value === undefined ? alt : value;
};
exports.getIntAttr = function (element, key) {
    return parseInt("" + exports.getAttr(element, key), 10);
};
exports.removeAttr = function (element, key) {
    element.removeAttribute(key);
};
